import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const NAV_HOVER = { scale: 1.1 };
const NAV_TAP = { scale: 0.9 };

const TestimonialNav = ({ total, currentIndex, onPrev, onNext, onSelect }) => {
  if (total <= 1) return null;

  return (
    <div className="flex items-center justify-center space-x-4 mt-8">
      <motion.button
        whileHover={NAV_HOVER}
        whileTap={NAV_TAP}
        onClick={onPrev}
        className="p-3 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 transition-colors"
        data-testid="testimonial-prev"
      >
        <ChevronLeft className="w-5 h-5 text-white" />
      </motion.button>

      <div className="flex space-x-2">
        {Array.from({ length: total }).map((_, idx) => (
          <button
            key={`testimonial-dot-${idx}`}
            onClick={() => onSelect(idx)}
            className={`w-2 h-2 rounded-full transition-all ${
              idx === currentIndex
                ? 'w-8 bg-orange-500'
                : 'bg-white/30 hover:bg-white/50'
            }`}
          />
        ))}
      </div>

      <motion.button
        whileHover={NAV_HOVER}
        whileTap={NAV_TAP}
        onClick={onNext}
        className="p-3 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 transition-colors"
        data-testid="testimonial-next"
      >
        <ChevronRight className="w-5 h-5 text-white" />
      </motion.button>
    </div>
  );
};

export default TestimonialNav;
